import { Component } from '@angular/core';

@Component({
  selector: 'stat-summary-footer',
  template: `<ng-content />`,
  host: {
    // border-0 first so the side widths we don't set stay 0 — otherwise `border-solid`
    // leaves the unset top edge at the `medium` (3px) default and doubles the box's bottom border.
    class: 'flex flex-wrap justify-between border-0 border-x border-b border-solid border-default bg-muted',
  },
})
export class StatSummaryFooterComponent {}
